/**
 * Blad zwrocony przez API. Normalizuje rozne formaty odpowiedzi backendu:
 * serwisy Tenify zwracaja raz JSON Spring Boota, raz goly tekst z
 * `ResponseEntity<String>` w `GlobalExceptionHandler`.
 */
export class ApiError extends Error {
  readonly status: number;
  /** Tresc bledu z backendu, o ile ja przyslal. */
  readonly detail: string | undefined;
  /** Surowe cialo odpowiedzi — przydatne przy diagnostyce. */
  readonly body: unknown;

  constructor(status: number, message: string, detail?: string, body?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.detail = detail;
    this.body = body;
  }

  /** Brak lub wygasniecie uwierzytelnienia. */
  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  /** Uzytkownik zalogowany, ale bez uprawnien do zasobu. */
  get isForbidden(): boolean {
    return this.status === 403;
  }

  /** Brak polaczenia z serwerem (status 0 ustawiamy przy bledzie sieci). */
  get isNetworkError(): boolean {
    return this.status === 0;
  }
}

/**
 * Wyciaga czytelny komunikat z ciala odpowiedzi bledu.
 * Obsluguje: JSON Spring Boota (`{message|error|detail}`), JSON bedacy golym
 * napisem oraz odpowiedz `text/plain`.
 */
export function extractErrorDetail(body: unknown): string | undefined {
  if (typeof body === 'string') {
    const trimmed = body.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }

  if (typeof body === 'object' && body !== null) {
    const record = body as Record<string, unknown>;
    for (const key of ['message', 'detail', 'error'] as const) {
      const value = record[key];
      if (typeof value === 'string' && value.trim().length > 0) {
        return value.trim();
      }
    }
  }

  return undefined;
}
